import Input from 'components/shared/Input/Input';
import s from './Search.module.scss';
import IconSearch from 'images/new-icons/search-dark.svg';
import { ReactComponent as IconClose } from 'images/new-icons/exit.svg';
import { useTranslation } from 'react-i18next';

const Search = ({ searchText, setSearchText }: { searchText: string, setSearchText: (text: string) => void }) => {
    const {t} = useTranslation() as any
  const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
    setSearchText((e.target as HTMLInputElement).value);
  };

  return (
    <div className={s.search_container}>
      <div className={s.search}>
        <Input
          icon={<img src={IconSearch} alt="search" className={s.search_icon} />}
          gray
          className={s.search_input}
          type="text"
          placeholder={t("Search products")}
          searchLeft
          value={searchText}
          onChange={handleSearchChange}
          suffix={searchText && <IconClose onClick={() => setSearchText('')} className={s.search_close} />}
        />
      </div>
    </div>
  );
};

export default Search;
